<template>
  <div class="container-fluid p-0">
    <form-container
      ref="formContainer"
      v-bind:model-state="modelState"
      v-bind:error-message="formError"
      :enabled="true"
      @form-change="onFormChange">
      <div class="row">
        <div class="col">
          <select-input v-bind="config.Operator" v-model="config.Operator.value" @on-return="onReturn" />
        </div>
        <div class="col" v-show="config.Operator.value !== 'empty'">
          <form-wrapper :form-config="config.Value" />
        </div>
        <div class="col-auto text-right align-self-end">
          <div style="margin-bottom: 13px;">
            <a href="javascript:void(0)" class="btn btn-outline-danger" @click="remove">X</a>
          </div>
        </div>
      </div>
    </form-container>
  </div>

</template>

<script>
import formmixin from '@/forms/components.js';
import {
  FormControl,
  FormTextConfig,
  FormSelectConfig,
  DateTimeConfig,
  FormBooleanConfig,
  FormNumericConfig
} from 'libs/classes/form.js';
import utils from 'libs/utils';
import { AdvancedFilterType } from 'libs/enums';
import { i18n } from '@/localize';

const getform = (column) => {
  const type = column.AdvancedFilterType;

  const form = new FormControl();
  const operatorOptions = [{
    text: i18n.t('grid.filters.gt'),
    value: '>',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }, {
    text: i18n.t('grid.filters.ge'),
    value: '>=',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }, {
    text: i18n.t('grid.filters.lt'),
    value: '<',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }, {
    text: i18n.t('grid.filters.le'),
    value: '<=',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }, {
    text: i18n.t('grid.filters.eq'),
    value: '=',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Default, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber, AdvancedFilterType.Bool]
  }, {
    text: i18n.t('grid.filters.ne'),
    value: '!=',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Default, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }, {
    text: i18n.t('grid.filters.contains'),
    value: 'contains',
    for: [AdvancedFilterType.Default]
  }, {
    text: i18n.t('grid.filters.notcontains'),
    value: 'notcontains',
    for: [AdvancedFilterType.Default]
  }, {
    text: i18n.t('grid.filters.empty'),
    value: 'empty',
    for: [AdvancedFilterType.DateTime, AdvancedFilterType.Default, AdvancedFilterType.Number, AdvancedFilterType.DecimalNumber]
  }].sort((a, b) => {
    if (a.text < b.text) return -1;
    if (a.text > b.text) return 1;
    return 0;
  }).filter(x => x.for.some(f => f === type));

  form.add(new FormSelectConfig('Operator', i18n.t('grid.filters.operator'), null, operatorOptions));
  if (type === AdvancedFilterType.DateTime) {
    form.add(new DateTimeConfig('Value', i18n.t('grid.filters.value'), null, true, true, true, false, false));
  } else if (type === AdvancedFilterType.Bool) {
    form.add(new FormBooleanConfig('Value', i18n.t('grid.filters.value'), false));
  } else if (type === AdvancedFilterType.Number || type === AdvancedFilterType.DecimalNumber) {
    const valueform = new FormNumericConfig('Value', i18n.t('grid.filters.value'), null);
    if (type === AdvancedFilterType.DecimalNumber) {
      valueform.setMinMaxStep(null, null, 0.01);
    }
    form.add(valueform);
  } else {
    form.add(new FormTextConfig('Value', i18n.t('grid.filters.value'), null));
  }
  return form;
};

export default {
  mixins: [formmixin],
  components: {},
  props: {
    column: {
      required: true
    },
    item: {
      required: true
    }
  },
  data () {
    const self = this;
    const form = getform(self.column);
    return {
      modelState: [],
      formError: null,
      form: form,
      config: form.config
    };
  },
  mounted () {
    let firstOperator = this.form.config.Operator.options[0];
    // set first operator if empty
    let formData = {
      Operator: this.item.operator || firstOperator.value,
      Value: this.item.value || this.form.config.Value.value // or default form value
    };

    this.form.loadData(formData);
    this.onFormChange();
  },
  methods: {
    onReturn () {
      this.$emit('change', this.operatorFilter);
    },
    onFormChange () {
      this.item.operator = this.operatorFilter.operator;
      this.item.value = this.operatorFilter.value;
    },
    remove () {
      this.$emit('remove', this.item);
    }
  },
  computed: {
    operatorFilter () {
      let formdata = this.form.getFormData();
      return {
        operator: formdata.Operator,
        value: formdata.Value
      };
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
